import axios from 'axios'

import config from '../../config'

const createWorkOrderLog = async ({ airportId, request }) => {
    
  try {
    const url = `${config.baseUrl}/${airportId}/workorder/${request.workOrderId}/WorkOrderLogs`

    const response = await axios.post(url, request)

    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export default createWorkOrderLog
